// extracted by mini-css-extract-plugin
export default {"wrapper":"s_wrapper__DljZB"};